import { Component, OnInit, Input, OnChanges } from "@angular/core";
import {
  trigger,
  style,
  state,
  transition,
  animate
} from "@angular/animations";
@Component({
  selector: "promo-highlight",
  templateUrl: "./promo-highlight.component.html",
  styleUrls: ["./promo-highlight.component.scss"],
  animations: [
    trigger("promoHighlightState", [
      state(
        "active",
        style({
          right: "1rem"
        })
      ),
      state(
        "inactive",
        style({
          right: "-100%"
        })
      ),
      transition(
        "active => inactive",
        animate("300ms cubic-bezier(0.6, -0.28, 0.735, 0.045)")
      )
    ])
  ]
})
export class PromoHighlightComponent implements OnInit, OnChanges {
  public popUpIsActive: boolean = false;
  public highlightIsActive: boolean = true;
  public state = "active";
  @Input() noPromos;

  constructor() {}

  ngOnInit() {
    console.log("active popup", this.popUpIsActive);
  }

  ngOnChanges(changes) {
    console.log("changes", changes);

    if (!changes.noPromos.currentValue) {
      this.toggleHighlight("active");
    } else {
      this.toggleHighlight("inactive");
    }
  }

  seePromo() {
    this.popUpIsActive = true;
  }

  updateFromPromo(event) {
    this.popUpIsActive = event.popUpActive;
  }

  toggleHighlight(state) {
    this.state = state;
    if (this.state === "active") {
      this.highlightIsActive = true;
    } else if (this.state === "inactive") {
      this.highlightIsActive = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/promo/promo-highlight/promo-highlight.component.ts